export default __webpack_public_path__ + "static/media/grubhub.1dc4d55e.png";